export default __webpack_public_path__ + "static/media/instagram-4.527a9364.jpeg";